"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { useState } from "react";
import { TelephonyProvider } from "@/components/telephony/telephony-provider";
import { WhatsAppCallProvider } from "@/components/whatsapp-calls/whatsapp-call-provider";
import { BrandingBootstrap } from "@/components/branding-bootstrap";
import { I18nBootstrap } from "@/components/i18n-bootstrap";
import { ClinicDateTimeProvider } from "@/components/clinic-date-time-provider";
// Static EN catalog as the initial provider value. providers.tsx is "use client", so
// getLocale() (next-intl/server) cannot be called here — the client bootstrap reconciles
// to the user's locale once /me resolves (Pitfall 3's one-frame reconcile; EN is the safe
// default source language). B2: this initial-props approach is pinned, not executor choice.
import en from "@/messages/en.json";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <I18nBootstrap initialLocale="en" initialMessages={en}>
          <ClinicDateTimeProvider>
            <TelephonyProvider>
              {/* WhatsApp (waxum) calls — deliberately a sibling state machine,
                  NOT merged into TelephonyProvider (which gates on webrtc_enabled
                  / sip_extension). Inert unless whatsapp_calls_enabled + calls.view. */}
              <WhatsAppCallProvider>
                <BrandingBootstrap />
                {children}
                <Toaster position="top-right" richColors closeButton />
              </WhatsAppCallProvider>
            </TelephonyProvider>
          </ClinicDateTimeProvider>
        </I18nBootstrap>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
